import { validateEnumTranslations } from '../../safety_checks';

//⚠️IMPACT attention changer dans le fichier prisma l'enum PaymentType
export enum PaymentMethod {
  CARD = 'CARD',
  SEPA_DEBIT = 'SEPA_DEBIT',
}

//⚠️IMPACT attention changer dans le fichier prisma l'enum PaymentType
export enum PaymentType {
  SUBSCRIPTION = 'SUBSCRIPTION',
  ONE_TIME = 'ONE_TIME',
}

//⚠️IMPACT attention changer dans le fichier prisma l'enum PaymentProvider
export enum PaymentProvider {
  STRIPE = 'STRIPE',
  GOCARDLESS = 'GOCARDLESS',
}

//⚠️IMPACT attention changer dans le fichier prisma l'enum PaymentStatus
export enum PaymentStatus {
  TIMEOUT = 'TIMEOUT',
  ERROR = 'ERROR',
  WAITING_PAYMENT = 'WAITING_PAYMENT',
  PAYMENT_METHOD_SETUP = 'PAYMENT_METHOD_SETUP',
  PAYED = 'PAYED',
  // Prélèvement SEPA lancé (`provider_payment_id`) : ni payé ni impayé, conclu par GoCardless.
  PROCESSING = 'PROCESSING',
}

/**
 * Issue d'un débit express d'un paiement one-time avec le moyen de paiement par défaut.
 * Valeur de contrôle API (pas un statut DB, pas de label user-facing) :
 *  - PAID            : carte débitée (off-session) → le webhook Stripe fait le fulfillment.
 *  - REQUIRES_ACTION : la banque exige une authentification (SCA/3DS) → bascule page hébergée.
 *  - FAILED          : carte refusée / mandat inutilisable / inéligible → bascule page hébergée.
 *  - PROCESSING      : prélèvement SEPA lancé sur le mandat par défaut → ni payé ni impayé, le
 *                      produit est livré à l'encaissement (quelques jours ouvrés).
 */
export enum ExpressPaymentStatus {
  PAID = 'PAID',
  REQUIRES_ACTION = 'REQUIRES_ACTION',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
}

/**
 * Issue du lancement d'un prélèvement SEPA depuis la page de paiement (`POST public/payment/sepa/start`).
 * Valeur de contrôle API (pas un statut DB, pas de label user-facing) :
 *  - PROCESSING : prélèvement lancé sur le mandat déjà signé du pro → paiement « Prélèvement en cours » ;
 *  - REDIRECT   : signature d'un nouveau mandat chez GoCardless (`redirect_url`) ; le prélèvement part
 *                 à la signature (webhook), jamais sur la foi du retour du navigateur ;
 *  - PAID       : rien à prélever (montant nul) → paiement validé tout de suite avec le mandat du pro.
 */
export enum SepaStartStatus {
  PROCESSING = 'PROCESSING',
  REDIRECT = 'REDIRECT',
  PAID = 'PAID',
}

export const PAYMENT_STATUS_COLOR_MAP = {
  [PaymentStatus.WAITING_PAYMENT]: 'cfixe-blue-button',
};

export const PAYMENT_STATUS_TRANSLATE_KEY = 'PAYMENT_STATUS_';

export const PaymentStatusTranslation = {
  'fr-FR': {
    [`${PAYMENT_STATUS_TRANSLATE_KEY}${PaymentStatus.TIMEOUT}`]: 'Paiement expiré',
    [`${PAYMENT_STATUS_TRANSLATE_KEY}${PaymentStatus.ERROR}`]: 'Refusé',
    [`${PAYMENT_STATUS_TRANSLATE_KEY}${PaymentStatus.WAITING_PAYMENT}`]: 'En attente',
    [`${PAYMENT_STATUS_TRANSLATE_KEY}${PaymentStatus.PAYMENT_METHOD_SETUP}`]: 'Mode de paiement enregistré',
    [`${PAYMENT_STATUS_TRANSLATE_KEY}${PaymentStatus.PAYED}`]: 'Payé',
    [`${PAYMENT_STATUS_TRANSLATE_KEY}${PaymentStatus.PROCESSING}`]: 'Prélèvement en cours',
  },
};

export const PAYMENT_ALERT_TITLE_TRANSLATE_KEY = 'PAYMENT_ALERT_TITLE_';

export const PaymentStatusTitleAlertBanner = {
  'fr-FR': {
    [`${PAYMENT_ALERT_TITLE_TRANSLATE_KEY}${PaymentStatus.ERROR}`]: 'Erreur de paiement',
    [`${PAYMENT_ALERT_TITLE_TRANSLATE_KEY}${PaymentStatus.TIMEOUT}`]: 'Délai de paiement dépassé',
    [`${PAYMENT_ALERT_TITLE_TRANSLATE_KEY}${PaymentStatus.WAITING_PAYMENT}`]: 'Paiement en attente',
    [`${PAYMENT_ALERT_TITLE_TRANSLATE_KEY}${PaymentStatus.PAYMENT_METHOD_SETUP}`]: 'Mode de paiement enregistré',
    [`${PAYMENT_ALERT_TITLE_TRANSLATE_KEY}${PaymentStatus.PAYED}`]: 'Payé',
    [`${PAYMENT_ALERT_TITLE_TRANSLATE_KEY}${PaymentStatus.PROCESSING}`]: 'Prélèvement SEPA lancé',
  },
};

export const PAYMENT_ALERT_DESC_TRANSLATE_KEY = 'PAYMENT_ALERT_DESC_';

export const PaymentStatusDescAlertBanner = {
  'fr-FR': {
    [`${PAYMENT_ALERT_DESC_TRANSLATE_KEY}${PaymentStatus.TIMEOUT}`]:
      'Le paiement a expiré. Aucun montant ne sera facturé.',
    [`${PAYMENT_ALERT_DESC_TRANSLATE_KEY}${PaymentStatus.ERROR}`]:
      "Le paiement n'a pas pu être effectué. Veuillez réessayer ou utiliser un autre moyen de paiement.",
    [`${PAYMENT_ALERT_DESC_TRANSLATE_KEY}${PaymentStatus.WAITING_PAYMENT}`]:
      'Le paiement est en attente de traitement.',
    [`${PAYMENT_ALERT_DESC_TRANSLATE_KEY}${PaymentStatus.PAYMENT_METHOD_SETUP}`]:
      'Moyen de paiement enregistré avec succès.',
    [`${PAYMENT_ALERT_DESC_TRANSLATE_KEY}${PaymentStatus.PAYED}`]: 'Le paiement a été effectué avec succès.',
    [`${PAYMENT_ALERT_DESC_TRANSLATE_KEY}${PaymentStatus.PROCESSING}`]:
      "Votre prélèvement SEPA a bien été lancé. Il sera confirmé d'ici quelques jours ouvrés.",
  },
};

//DONT TOUCH below this line
validateEnumTranslations(PaymentStatus, PaymentStatusTranslation, PAYMENT_STATUS_TRANSLATE_KEY, true);
validateEnumTranslations(PaymentStatus, PaymentStatusTitleAlertBanner, PAYMENT_ALERT_TITLE_TRANSLATE_KEY, true);
validateEnumTranslations(PaymentStatus, PaymentStatusDescAlertBanner, PAYMENT_ALERT_DESC_TRANSLATE_KEY, true);
